module.exports = __webpack_public_path__ + "img/Nickolson.da1abbc1.jpg";